import React, { Component } from "react";
import AppliedCard from "../AppliedCard/AppliedCard";
import {
  GetListings,
  TranslateListing,
  GetApplicationStatus,
  ResubmitApplication
} from "../../utils/consts";
import Spinner from "@atlaskit/spinner/dist/cjs/Spinner";

export default class ProfileAppliedCard extends Component {
  state = { loading: true, my: this.props.my };

  componentDidMount() {
    this.getListing();
  }

  static async getDerivedStateFromProps(props, state) {
    // console.log(props);
    // console.log(state);
    const user = props.my;
    const status = await GetApplicationStatus(user);
    console.log(status);
    if (status) {
      ResubmitApplication(user.uid)
        .then(() => {
          props.addFlag({
            appearance: 2,
            title: "Application Updated"
          });
        })
        .catch(error => {
          console.log(error);
          props.addFlag({
            appearance: 2,
            title: "Error - Please Retry"
          });
        });
    }
    return null;
  }

  getListing = async () => {
    try {
      const listings = await GetListings(this.props.lid);
      const untranslated = listings[this.props.lid];
      const listing = await TranslateListing(untranslated);
      this.setState({ listing, loading: false });
    } catch (error) {
      this.setState({ listing: null, loading: false });
      this.props.addFlag({
        appearance: 2,
        title: "Error - Please Try Again"
      });
    }
  };

  render() {
    // console.log(this.state);
    return (
      <div
        style={{
          width: "300px",
          backgroundColor: "rgba(225,225,225,0.33)",
          padding: "10px",
          borderRadius: "4px 4px 0 0"
        }}
        className="profile-applied-card"
      >
        {this.state.loading ? (
          <Spinner />
        ) : (
          <AppliedCard
            hideCard={true}
            hideTitle={false}
            hideSection={false}
            hideMissing={true}
            hideActions={true}
            listing={this.state.listing}
            addFlag={this.props.addFlag}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProfileAppliedCard/ProfileAppliedCard.js